import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "src/utils/cn";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn("mb-2 block text-sm font-medium text-slate-700", className)}
    {...props}
  />
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
